function Spinner() {
  return (
    <div className="spinnerContainer">
      <div className="spinner"></div>
    </div>
  );
}

export default Spinner;
